import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { CustomerManageService } from '../shared/customer-manage.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ControlValidationMessagesService } from '../../shared/validators/control-validation-messages.service';
import { MvdNowUserSearchCriteria } from './models/mvdnow-user-search-criteria.model';
import { MvdNowUserSearchResult } from './models/mvdnow-user-search-result.model';

export class MVDNowLinkCustomerContext {

    constructor(public customerNumberId: number) { }
}

@Component({
    templateUrl: './mvdnow-link-customer-modal.html'
})

export class MVDNowLinkCustomerModalComponent extends BaseComponent {
    public form: UntypedFormGroup;
    public showSearchButtonLoading = false;
    public showSaveButtonLoading = false;
    public mvdNowUsers: MvdNowUserSearchResult[] = null;
    public selectedUser: any;
    private customerNumberId: number;

    constructor(public location: PlatformLocation,
        public fb: UntypedFormBuilder,
        private customerService: CustomerManageService,
        public dialogRef: MatDialogRef<MVDNowLinkCustomerModalComponent>,
        public mvdModalService: MvdModalService,
        @Inject(MAT_DIALOG_DATA) public data: MVDNowLinkCustomerContext) {
        super();

        this.customerNumberId = this.data.customerNumberId;
        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() {
        this.form = this.fb.group({
            'email': [null, Validators.compose([Validators.required, ControlValidationMessagesService.optionalEmailValidator])]
        });
    }

    public cancel() {
        this.dialogRef.close();
    }

    public reset() {
        this.selectedUser = null;
        this.mvdNowUsers = null;
        this.showValidationComponent = false;
        this.form.reset();
    }

    public searchUnlinkedUsers() {
        this.selectedUser = null;
        this.showValidationComponent = false;
        if (this.form.valid) {
            this.showSearchButtonLoading = true;
            let searchCriteria: MvdNowUserSearchCriteria = Object.assign({}, this.form.value);
            this.customerService.searchUnlinkedUsers(searchCriteria).pipe(
                finalize(() => {
                    this.showSearchButtonLoading = false;
                }))
                .subscribe(
                    (data) => {
                        this.mvdNowUsers = data.result;
                    },
                    (error) => {
                        this.handleValidationResult(error);
                    });
        }
    }

    public linkCustomerToMvdNowUser() {
        if (this.selectedUser) {
            this.showSaveButtonLoading = true;
            this.customerService.linkCustomerToMvdNowUser(this.customerNumberId, this.selectedUser.id).pipe(
                finalize(() => {
                    this.showSaveButtonLoading = false;
                }))
                .subscribe(
                    () => {
                        this.dialogRef.close(true);
                    },
                    (error) => {
                        this.handleValidationResult(error);
                    });
        }
    }
}
